import type { AITask, AIResult, ContextSource, ContextGroup } from '../../../../server/ai/contracts';
export type { AITask, AIResult, ContextSource, ContextGroup };
export interface AISettings {
 enabled: boolean; provider_id: string; audit_enabled: boolean; context_groups: ContextGroup[]; version: number;
 providers: { id: string; name: string; mode: 'simulated'|'live'; tasks: AITask[] }[]; tasks: AITask[];
}
export interface Generation {
 id: string; task: AITask; relationship_id: string|null; conversation_id: string|null; campaign_id: string|null;
 state: 'generating'|'succeeded'|'failed'; provider_id: string; provider_mode: 'simulated'|'live'; model: string|null;
 created_at: string; finished_at: string|null; error_code: string|null; hidden: boolean; stale: boolean;
 output: AIResult|null; sources: ContextSource[]; notice: string|null; used: { action: string; approved_at: string }[];
}
export const taskLabels: Record<AITask,string> = {
 relationship_memory:'Relationship memory', conversation_summary:'Conversation summary', extract_note:'Propose a CRM note',
 suggest_tags:'Suggest relationship tags', suggest_follow_up:'Suggest a follow-up', action_items:'Find action items',
 draft_reply:'Draft a reply', rewrite_tone:'Rewrite tone', shorten:'Make it shorter', improve:'Improve clarity', personalize_outreach:'Personalize this message',
};
